import _inheritsLoose from '@babel/runtime/helpers/builtin/es6/inheritsLoose';
import { Component } from 'react';

var Rifm =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Rifm, _React$Component);

  function Rifm(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this._state = null;

    _this._handleChange = function (evt) {
      var value = evt.target.value;
      var input = evt.target;
      var op = value.length > _this.props.value.length;

      var noOp = _this.props.value === _this.props.format(value);

      _this.setState({
        value: value,
        local: true
      }, function () {
        var selectionStart = input.selectionStart;
        var refuse = _this.props.refuse || /[^\d]+/gi;
        var before = value.substr(0, selectionStart).replace(refuse, '');
        _this._state = {
          input: input,
          before: before,
          op: op
        };

        if (_this.props.replace && _this.props.replace(_this.props.value) && op && !noOp) {
          var start = -1;

          for (var i = 0; i !== before.length; ++i) {
            start = Math.max(start, value.indexOf(before[i], start + 1));
          }

          var c = value.substr(start + 1).replace(refuse, '')[0];
          start = value.indexOf(c, start + 1);
          value = "" + value.substr(0, start) + value.substr(start + 1);
        }

        _this.props.onChange(_this.props.format(value));
      });
    };

    _this.state = {
      value: props.value,
      local: false
    };
    return _this;
  }

  Rifm.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    return {
      value: state.local ? state.value : props.value,
      local: false
    };
  };

  var _proto = Rifm.prototype;

  _proto.render = function render() {
    var _handleChange = this._handleChange,
        value = this.state.value,
        children = this.props.children;
    return children({
      value: value,
      onChange: _handleChange
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _state = this._state;

    if (_state) {
      var value = this.state.value;
      var start = -1;

      for (var i = 0; i !== _state.before.length; ++i) {
        start = Math.max(start, value.indexOf(_state.before[i], start + 1));
      }

      if (this.props.replace && _state.op) {
        while (value[start + 1] && (this.props.refuse || /[^\d]+/gi).test(value[start + 1])) {
          start += 1;
        }
      }

      _state.input.selectionStart = start + 1;
      _state.input.selectionEnd = start + 1;
    }

    this._state = null;
  };

  return Rifm;
}(Component);

export { Rifm };
